__turbopack_context__.v({
  "SocialLinks": "SocialLinks-module-sass-module__SQzimG__SocialLinks",
});
